// import { PieChart } from "react-native-chart-kit";
import React from "react";
import { View, Text, Dimensions } from "react-native";
import { VictoryPie, VictoryContainer, VictoryLabel } from "victory";

const StatsCard = ({ pieData, colorPieChart, colorPie, text }) => {
	return (
		<View className="flex-col rounded-lg border-solid border bg-[#1E272C] mt-3 mx-1 py-2 drop-shadow-2xl">
			<View className="items-center justify-center">
				<Text className="text-xl font-bold text-white">{text}</Text>
			</View>
			<View className="sm:flex-col md:flex-row md:space-x-14 justify-center items-center">
				<View className="">
					<VictoryPie
						data={pieData}
						containerComponent={
							<VictoryContainer responsive={false} />
						}
						colorScale={colorPieChart}
						labels={() => null}
						width={290}
						height={250}
						innerRadius={110}
						padAngle={() => 1.5}
						cornerRadius={() => 5}
					/>
				</View>
				<View className="flex-shrink md:w-1/2">
					<View className="flex-col space-y-3">
						{pieData.map((item, index) => {
							return (
								<View
									key={index}
									className="flex-row space-x-5 items-center"
								>
									<View
										className={`w-[20px] h-[20px] ${colorPie[index]} rounded-full`}
									></View>
									<Text className="text-white text-[15px] md:text-xl">
										{item.y} {item.x}
									</Text>
								</View>
							);
						})}
					</View>
				</View>
			</View>
		</View>
	);
};

export default StatsCard;
